import { z } from 'zod'

export const webhookFormSchema = z.object({
  url: z.string().url(),
  method: z.string(),
})
